/*
    vu-nav/SidebarState.js -- Sidebar state management
 */

import {allow} from '@/paks/js-polyfill'
import {State} from '@/paks/vu-state'
import {getRoutePath} from '@/paks/vu-app'

export default class SidebarState {
    show = null

    saveState(state) {
        return allow(state, ['show'])
    }

    loadState(state) {
        return allow(state, ['show'])
    }

    toggle() {
        if (State.config.features.nav?.sidebarHide) {
            this.show = this.show == 'full' ? 'none' : 'full'
        } else {
            this.show = this.show == 'full' ? 'mini' : 'full'
        }
    }

    changeDashboard() {
        return this.changePath()
    }

    changePath() {
        let priorShow = this.show
        if (State.app.mobile) {
            this.show = 'none'
        } else if (this.show == 'none') {
            this.show = 'full'
        }
        return this.show != priorShow
    }
}
